import { Injectable } from '@angular/core';
import { Endereco, TipoEndereco } from '../models/endereco';
import { Observable } from 'rxjs/Rx';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class EnderecoService {

  constructor(private globalService: GlobalService, private http: HttpClient) { }

  consultarPorIdCliente(idCliente: string) {
    return this.http.get<Endereco[]>(globals.apiUrl + '/api/EnderecoAD/Lista',
      { params: new HttpParams().set('cli', idCliente) });
  }

  salvar(endereco: Endereco) {

    return this.http.post(globals.apiUrl + '/api/EnderecoAD/Salvar', endereco,
      { responseType: 'text' });
  }

  consultarTipos() {
    return this.http.get<TipoEndereco[]>(globals.apiUrl + '/api/EnderecoAD/ListaTipos');
  }
}
